import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { BannerContainer, CategoryImage } from './styled';

export default function CategoryBanner({ banner, pageType }) {
  const [bannerImage, setBannerImage] = useState(banner);
  const router = useRouter();
  useEffect(() => {
    if (pageType == 'topic') {
      setBannerImage(banner ? banner : '/images/topicDefaultImage.png');
    } else setBannerImage(localStorage.getItem('category_img'));
  }, [router.asPath]);
  return bannerImage ? (
    <BannerContainer>
      <CategoryImage
        src={`${bannerImage}?tr=w-420,q-90`}
        srcSet={`${bannerImage}?tr=w-420,q-90 2w, ${bannerImage}?tr=w-900,q-90 720w`}
        sizes="(max-width: 720px) 2px,720px"
        alt=""
      />
    </BannerContainer>
  ) : null;
}
